import { Routes } from '@angular/router';
import { AdminLayoutComponent } from '../../layouts/admin-layout/admin-layout.component';
import { PAYMENT_CONFIG } from './payment.config';
import { removeLeadingCharacter } from './utils/remove-leading-character';

export const routes: Routes = [
  {
    path: removeLeadingCharacter(
      '/',
      PAYMENT_CONFIG.checkout.onSuccessTargetUrl,
    ),
    component: AdminLayoutComponent,
  },
];
